import classNames from "classnames/dedupe";
import React, { FC } from "react";
import { ILink, Link } from "../../ActionsSelectors/Link";
import LinkList, {
  ILinkListProps,
} from "../../ActionsSelectors/LinkList/LinkList";

export interface IDesktopMenuListProps extends ILinkListProps {
  titleLink?: ILink;
  disablePointerEffects?: boolean;
}

/** Helper component, decorates 'LinkList' with predefined Desktop Menu classes */
const DesktopMenuList: FC<IDesktopMenuListProps> = (props) => {
  const { titleLink, classes, children, disablePointerEffects, ...other } =
    props;

  return (
    <LinkList
      listTitle={
        <Link
          {...titleLink}
          disabled={disablePointerEffects}
          classes={{
            root: classNames("nav-menu__head", {
              "cursor-default": !titleLink?.href,
            }),
          }}
        />
      }
      classes={{
        root: classNames("nav-menu__list", "cursor-default", classes?.root),
        listItem: "nav-menu__item",
        link: "nav-menu__link",
      }}
      {...other}
    >
      {children}
    </LinkList>
  );
};

export default DesktopMenuList;
